var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeftTop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 429,
    height: 166,
    viewBox: "0 0 429 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_19_442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345.363 50.5001C357.363 53.7001 379.696 58.5001 389.363 60.5001C394.03 73.6667 402.363 105.7 398.363 128.5C393.363 157 377.863 128.5 357.863 121.5C337.863 114.5 308.363 121.5 287.363 121.5H228.863C203.363 121.5 170.363 128.5 130.363 133.5C90.363 138.5 74.863 135 46.863 128.5C18.863 122 24.863 113.5 20.363 100C16.763 89.2 40.863 88.5 53.363 89.5C62.1963 88.6667 80.063 85.8 80.863 81C81.863 75 60.363 66.5 37.863 50.5001C19.863 37.7001 27.0296 37.5001 32.863 39L53.363 29C68.5296 29.8333 100.063 33 104.863 39C110.863 46.5 120.363 60.5001 130.363 60.5001C140.363 60.5001 163.363 66.5 183.363 66.5H203.363C195.03 61.1667 177.863 50.5001 175.863 50.5001C173.363 50.5001 188.363 42.5 203.363 39C218.363 35.5 227.363 45.5 233.863 50.5001C240.363 55.5001 254.363 77 276.863 75.5C294.863 74.3 291.363 65 287.363 60.5001C301.696 55.8334 333.363 47.3001 345.363 50.5001Z",
    fill: "url(#paint0_linear_19_442)",
    fillOpacity: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_19_442",
    x: -9,
    y: 0,
    width: 437.418,
    height: 169.922,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.5,
    result: "effect1_foregroundBlur_19_442"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19_442",
    x1: 209.709,
    y1: 29,
    x2: 209.709,
    y2: 140.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.255208,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F3FE7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftTop);
export default __webpack_public_path__ + "static/media/left-top.f28c70e1c3fff55a0b280f290430222a.svg";
export { ForwardRef as ReactComponent };